<template>
  <main class="container new_product">
    <souhuo-list
      :data-list="dataList"
      :scroll-disabled="scrollDisabled"
      :is-newcomer="isNewcomer"
      :show-head="false"
      head-title="新品首发"
      @loadMore="loadMore"
      @entoDetailPage="entoDetailPage"
    >
      <!-- 增加展现筛选条件 start -->
      <div class="filterBox" slot="filterBox">
        <div
          class="filterItem"
          @click="IsStockNoZero = !IsStockNoZero"
          :class="{ active: item.IsStockNoZero === IsStockNoZero }"
          v-for="(item, index) in filterList"
          :key="index"
          v-text="item.text"
        ></div>
      </div>
      <!-- 增加展现筛选条件 end -->
    </souhuo-list>
    <!-- no more -->
    <segement-line v-if="!haveMore" line-text="没有更多商品啦"> </segement-line>
    <!-- loading -->
    <segement-line v-if="haveMore" line-text="正在加载" :is-load="true">
    </segement-line>
    <!-- 返回顶部 -->
    <quick-top
      @returnTop="returnTop"
      :isReturn="isReturn"
      :positionBtm="20"
    ></quick-top>
  </main>
</template>

<script>
import SouhuoList from "@/components/puppetComponent/SouhuoList";
import SegementLine from "@/components/puppetComponent/SegementLine";
import QuickTop from "@/components/smartComponent/QuickTop";
import { NewStart, NewStartNoLogin } from "@/api/souhuo";
import { Indicator, Toast } from "mint-ui";
import { mapGetters } from "vuex";
import Utils from "@/utils/base";

export default {
  data() {
    return {
      dataList: [],
      haveMore: true,
      scrollDisabled: false,
      pageScrollTop: 0,
      container: null,
      isNewcomer: false, // 是否是新人
      // 获取数据接口，是否为最后一条
      isLastOne: false,
      isReturn: false,
      filterList: [
        {
          text: "全部",
          IsStockNoZero: false,
        },
        {
          text: "有库存",
          IsStockNoZero: true,
        },
      ],
      IsStockNoZero: true, // 是否库存排序 false:全部 true:有库存
    };
  },
  components: {
    SouhuoList,
    SegementLine,
    QuickTop,
  },
  computed: {
    ...mapGetters(["loginState"]),
  },
  mounted() {
    // this.fetchData()
    // 绑定监听事件
    this.$nextTick(() => {
      this.container = document.getElementsByClassName("container")[0];
      this.container.addEventListener("scroll", this.handleScroll);
    });
  },
  methods: {
    reFetchPage(from) {
      if (from.name === "goodsDetail" && this.container) {
        this.$nextTick(() => {
          this.container.scrollTop = this.pageScrollTop;
        });
      } else {
        this.isNewcomer = Utils.getNewcomerStorage();
        this.dataList = [];
        this.dataList.splice(0);
        this.pageScrollTop = 0;
        this.isReturn = false;
        this.isLastOne = false;
        this.IsStockNoZero = true;
        this.fetchData();
      }
    },
    fetchData(isDropDown = false) {
      Indicator.open({
        text: "加载中",
        spinnerType: "triple-bounce",
      });
      let params = {
        DropDown: isDropDown,
        IsStockNoZero: this.IsStockNoZero,
      };
      this.scrollDisabled = true;
      if (this.loginState) {
        NewStart(params)
          .then((res) => {
            this.dataList = [...this.dataList, ...res.DataList];
            this.isLastOne = res.BoolSID;
            if (res.BoolSID) {
              this.haveMore = false;
            } else {
              this.haveMore = true;
            }
            this.scrollDisabled = false;
            Indicator.close();
          })
          .catch((res) => {
            this.haveMore = false;
            Indicator.close();
            if (res.ErrMsg) {
              Toast(res.ErrMsg);
            }
          });
      } else {
        NewStartNoLogin(params)
          .then((res) => {
            this.dataList = [...this.dataList, ...res.DataList];
            this.isLastOne = res.BoolSID;
            if (res.BoolSID) {
              this.haveMore = false;
            } else {
              this.haveMore = true;
            }
            this.scrollDisabled = false;
            Indicator.close();
          })
          .catch((res) => {
            this.haveMore = false;
            Indicator.close();
            if (res.ErrMsg) {
              Toast(res.ErrMsg);
            }
          });
      }
    },
    loadMore() {
      if (this.isLastOne) {
        this.haveMore = false;
        return;
      }
      this.haveMore = true;
      this.fetchData(true);
    },
    // 进入详情页
    entoDetailPage(productID, isStockNoZero, isFreeCard) {
      this.$router.push({
        name: "goodsDetail",
        query: {
          productID: productID,
          isFreeCard: isFreeCard,
        },
      });
    },
    // 返回顶部
    returnTop: function () {
      let container = this.container;
      container.scrollTop = 0;
    },
    // 滚动监听
    handleScroll(e) {
      // 滚动高度
      let scrollTop = this.container.scrollTop;
      this.pageScrollTop = scrollTop;
      // 屏幕高度
      let documentH =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (scrollTop > documentH) {
        this.isReturn = true;
      } else {
        this.isReturn = false;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.reFetchPage(from);
    });
  },
  watch: {
    IsStockNoZero() {
      // console.log(val)
      this.dataList = [];
      this.pageScrollTop = 0;
      this.fetchData();
    },
  },
};
</script>

<style scoped="scoped">
.new_product {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #f5f5f5;
}
.filterBox {
  position: relative;
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 0 3% 4%;
  box-sizing: border-box;
  /* margin-bottom: 10px; */
}
/* .filterBox::before {
    position: absolute;
    content: '';
    bottom: 0;
    left: 50%;
    margin-left: -48%;
    width: 96%;
    height: 1px;
    background-color: #f2f2f7;
  } */
</style>
